import { normalize } from 'normalizr';

import * as api from '../apis/transactions';
import { apiCall } from '~/lib/redux/api';
import { EntityActions, TransactionActions } from './consts';
import { TransactionNormalizer } from './normalize';
import { TransactionFilter } from '../models/transactions';
import { defaultTablePageSize } from '~/common/components/consts';


export function getTransactionById(transactionId: string) {
  return apiCall({
    actions: [
      TransactionActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, TransactionActions.LOAD_SUCCESS],
      TransactionActions.LOAD_ERROR,
    ],
    normalizer: TransactionNormalizer,
    fn: () => api.getTransactionById(transactionId),
  });
}

// TODO: Use constants
export function getOrgTransactions(orgId: string, filter: TransactionFilter=null, offset=0, limit=defaultTablePageSize) {
  return apiCall({
    actions: [
      TransactionActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, TransactionActions.LOAD_LIST_SUCCESS],
      TransactionActions.LOAD_ERROR,
    ],
    normalizer: [TransactionNormalizer],
    fn: () => api.getOrgTransactions(orgId, filter, offset, limit),
  })
}

export function setTransactionsCurrentPage(page = 0) {
  return {
    type: TransactionActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
